// @ts-ignore
import CV from '../assets/Cv/CV Lapouge Maxime.pdf'

const links = {
  home: '/',
  about: '/about',
  cv: '/cv',
  download: {
    cv: CV,
  },
  externalLinks: {
    linkedin: 'https://www.linkedin.com/in/maxime-lapouge69/',
    github: 'https://github.com/Moxiii',
  },
}
export default links
